import React from "react";
import styled from "styled-components";
import empty_bar from "../assets/empty-bar.png";

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const Icon = styled.img`
  margin-right: -20%;
  z-index: 1;
`;

export default function EmilePetStatus({ image }) {
  return (
    <Container>
      <Icon src={image} alt="status-icon" />
      <img src={empty_bar} alt="bar-icon" />
    </Container>
  );
}
